import { UsersServiceAPI } from '@API/data-services/users-service'
import { DEFAULT_STALE_DATA_TIMEOUT } from '@AppState/app-config'
import { RootState } from '@AppState/redux-store'
import { Routes } from '@Components/main-app/types'
import { LoadingRows } from '@Components/util/loading-rows'
import { AuthScopes } from '@Generated/back-office-client/src'
import { Button, Flex, Skeleton, Table, Link as ThemedLink } from '@radix-ui/themes'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

export const RolesList = () => {
  const { currentUser, activeCustomerId } = useSelector((state: RootState) => state.users)

  const {
    data: roles,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [`${activeCustomerId}-roles`],
    staleTime: DEFAULT_STALE_DATA_TIMEOUT,
    queryFn: () => UsersServiceAPI.getCustomerRoles(),
  })

  const canWrite = currentUser?.scopes.includes(AuthScopes.writeroles)

  const rows = roles?.map((r) => {
    return (
      <Table.Row key={r.id}>
        <Table.RowHeaderCell>
          {canWrite ? (
            <ThemedLink asChild>
              <Link to={`${Routes.EDIT_ROLE.replace(':id', r.id)}`} state={r}>
                {r.name}
              </Link>
            </ThemedLink>
          ) : (
            r.name
          )}
        </Table.RowHeaderCell>
        <Table.Cell>{r.description}</Table.Cell>
        <Table.Cell>{r.scopes ? r.scopes.map((s) => s.name).join(',') : ''}</Table.Cell>
      </Table.Row>
    )
  })

  return (
    <Flex justify="center" direction="column" gap="5">
      {canWrite ? (
        <Flex justify="end">
          <Link to={Routes.CREATE_ROLE}>
            <Button style={{ cursor: 'pointer' }}>Create</Button>
          </Link>
        </Flex>
      ) : null}

      {isError ? <Flex justify="center">Error loading roles</Flex> : null}

      {isError ? null : (
        <Skeleton loading={isLoading}>
          {isLoading || rows?.length ? (
            <Table.Root>
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeaderCell>Name</Table.ColumnHeaderCell>
                  <Table.ColumnHeaderCell>Description</Table.ColumnHeaderCell>
                  <Table.ColumnHeaderCell>Scopes</Table.ColumnHeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>{isLoading ? <LoadingRows /> : rows}</Table.Body>
            </Table.Root>
          ) : (
            <Flex justify="center">No roles exist...yet</Flex>
          )}
        </Skeleton>
      )}
    </Flex>
  )
}
